import {useFormContext} from "react-hook-form";

import {FormLabel} from "@/components/form/FormLabel.tsx";
import {FormSubtext} from "@/components/formSubtext/FormSubtext.tsx";
import {SelectOption} from "@/components/select/Select.types.ts";
import {getFormError} from "@/lib/form/form.utils.ts";
import {FieldProps} from "@/pages/checks/components/form/fields/common.ts";

interface Props extends FieldProps {
  options: SelectOption[];
}

export const RadioGroupField = ({
  name,
  label,
  className,
  tooltip,
  supportLink,
  helpText,
  options,
  required,
  labelTypography,
}: Props) => {
  const {
    register,
    formState: {errors},
  } = useFormContext();
  const fieldError = getFormError(name, errors);
  const extraOptions: Record<string, string> = {};
  if (required) {
    extraOptions["required"] = "This field is required";
  }
  return (
    <div className={className}>
      <FormLabel helpText={tooltip} forId={name} required={required}>
        {label}
      </FormLabel>
      <>
        {options.map((o) => (
          <div className="form-check" key={o.value}>
            <input
              className="form-check-input"
              {...register(name)}
              type="radio"
              value={o.value}
              name={name}
              id={`id-${o.label}`}
            />
            <FormLabel className="form-check-label" forId={`id-${o.label}`} labelTypography={labelTypography}>
              {o.label}
            </FormLabel>
          </div>
        ))}
      </>
      <FormSubtext subText={helpText} supportLink={supportLink} error={fieldError?.toString()} />
    </div>
  );
};
